import { render, staticRenderFns } from "./CreateEndorsement.vue?vue&type=template&id=2d7a1434"
import script from "./CreateEndorsement.vue?vue&type=script&lang=ts"
export * from "./CreateEndorsement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports